export function getKiyaku(building_id: string) {
  let building_title = 'ろう・難聴児のオンライン対話学習コミュニティ「Circle O」';
  let name_full = '「Circle O（サークルオー）」（以下「サークルオー」といいます）';
  let name = 'サークルオー';
  if (building_id === 'da01') {
    building_title = 'ろう・難聴児専門の児童発達支援・放課後等デイサービス「デフアカデミー」';
    name = 'デフアカデミー';
    name_full = '「デフアカデミー」';
  }
  const kiyaku = `
${building_title} 先生契約約款

第１条（目的）
本約款は、NPO法人 Silent Voice（以下「当法人」といいます）が、先生との間で、インターネットを用いたオンライン対話学習事業${name_full}におけるサークルオー先生契約約款に関する内容を定めることを目的とします。

第２条（定義）
本約款で定める用語は、以下のとおりとします。
① 本契約：当法人と先生との間で成立した先生業務委託契約をいいます。
② 生徒：利用契約によって、本サービスの利用者として登録された方をいいます。
③ 利用契約者：当法人と${name}利用契約約款に基づく契約を締結した者をいいます。
但し、生徒が成年の場合は生徒が利用契約者となり、生徒が未成年の場合は、その保護者が
利用契約者となります。
④ 先生：当法人との契約により、先生として登録され、生徒の指導にあたる者をいいます。
⑤ 本サービス：当法人が先生に対して提供するオンライン対話学習のサービスをいいます。
⑥ 日報：先生が授業後、授業内容報告として記入するシートをいいます。

第３条（約款及びマニュアルの適用）
１．本約款は、全ての先生に適用されます。
２．先生は、当法人が${name}の円滑な運営を目的とする約款及びマニュアル（以下「約款等」といいます）を遵守する義務を負います。
３．約款等は、当法人の判断により変更することがあります。この場合、当法人の定める施行日から変更後の約款等が適用されます。
４．当法人と先生が約款等と異なる事項を文書により合意した場合は、当該合意が約款等に優先します。

第４条（契約の成立）
１．先生は、当法人の定める方式に従って、登録情報を登録し、本契約を申し込みます。
２．当法人は、登録済みの先生に対して、当法人の定める方法で面談を行い、本契約締結承諾の可否
を決めます。
３．先生の、契約申込みに対して、当法人が承諾した時点で、本契約が成立するものとします。本契約の成立をもって約款等も有効とします。
４．以下の場合は、当法人は、本契約の承諾を撤回することができます。
① 先生が、申込時に虚偽の事項を申告した場合
② 先生が、本契約に違反をした場合
③ 先生に、過去に約款違反を理由とする解除が存在するとき
④ その他相当の事由がある場合

第５条（事業活動）
１．当法人は、先生に対して特定の活動について排他的ないし独占的権利を与えるものではなく、固有の権利を認めないものとします。
２．当法人及び先生は、「${name}の中で互いの利益が相反する可能性があることを認識し、当該利益の相反があった場合は、円滑な オンライン対話学習事業活動がなされるよう相互に協力し、解決しなければならないものとします。

第６条（個人情報等の利用）
１．先生は、当法人に提供した個人情報を、当法人、他の先生、利用契約者又は生徒が、以下の目的で利用することをあらかじめ承諾します。
① 利用契約者又は生徒に対する先生紹介
② アンケート調査
③ 前各号と関連する業務の遂行目的
２．当法人は、先生の個人情報その他秘密情報を契約期間中はもとより、契約終了後においても第三者に漏洩しないものとします。

第７条（先生業務）
１．業務の詳細は、別途定めるマニュアル記載のとおりとします。

第８条（先生業務の実施）
１．先生は、本約款その他の約款に従い、関係諸法規を遵守して、先生業務を行います。
２．先生は、登録事項に変更があった場合は、遅滞なく当法人へ連絡し登録変更手続きを採ります。
３．先生は、各授業の終了後、当法人の指定する期限までに日報を、当法人の定める方法で提出するものとします。

第９条（報告義務）
１．先生は、当法人が求めた場合は、本サービスに関する活動について報告しなければならないものとします。
２．先生は、利用契約者又は生徒等から苦情、クレームがあった場合は、直ちに当法人に報告しなければならないものとします。

第１０条（研修）
１．当法人は、先生に対して先生業務を実施するのに必要と判断した場合は、先生に対して研修を命じることができます。尚、研修の受講にかかる費用は、先生の負担とします。
２．当法人は、先生が先生業務を遂行するために必要な最低限の知識を取得していないと判断した場合は、先生業務の開始を許可しないことができます。

第１１条（マニュアル等の使用許諾）
１．当法人は、先生に対して、先生業務の遂行のために、各種マニュアルを貸与します。
２．当法人は、先生に対して、当法人の指定した、ノウハウ、商標、著作物等を、当法人の指示に従って使用することを許諾します。
３．先生は、前２項のマニュアル、ノウハウ、商標、著作物等を、自己の先生業務の遂行目的のみに使用し、当法人の秘密情報として管理します。

第１２条（オンライン会議用ツールの利用）
１．先生は、当法人が指定するオンライン会議用ツールを、当法人の指示に従って利用します。
２．先生業務の実施に必要な機器及びソフトウェアは、先生の責任で、これを用意し、あらかじめ、その機能を確認しなければなりません。
３．業務の実施に要するインターネット接続に関する通信費用、その他の費用は先生の負担とします。また、コンピュータウィルス対策など利用するために要する費用も先生の負担とします。
４．先生は、オンライン会議用ツールを利用する環境が、常に良好な状態となるようにします。
５．業務時に発生した、オンライン会議用ツール以外の機能の不具合により生じた障害について、先生業務に支障が生じても、当法人は一切責任を負わないこととします。

第１３条（遵守事項）
先生は、本サービスの事業価値、当法人の対外的な信頼を破壊することのないよう十分な注意を払い、先生業務を行わなければなりません。

第１４条（競業避止）
先生は、利用契約者、生徒との間で、先生業務と同一又は類似のサービス提供に関する契約を締結してはいけません。

第１５条（秘密保持）
先生は、先生業務の遂行において相手方より得た秘密事項について、本契約の期間中並びに契約の前後を問わず、当法人の事前の同意を得ることなく、第三者に開示・漏洩等してはならないものとします。ただし、以下の情報は秘密情報から除外されます。
（１）開示された時点で既に公知の情報
（２）開示された時点で被開示者が既に知っていた情報
（３）開示された後、被開示者の責めによらず公知となった情報
（４）被開示者が第三者より正当に得た情報
（５）被開示者が、開示された情報と無関係に、自ら開発、創作した情報
（６）法令等に基づき開示が義務づけられあるいは要請されている情報
（７）公的機関より開示を義務づけられ、または要求された情報

第１６条（禁止事項）
１．先生は、先生業務の全部又は一部を第三者に再委託してはなりません。ただし、当法人及び先生が協議の上、当法人が書面による再委託の許可をした場合に限り、先生は第三者に再委託をすることができます。
２．先生は、本契約上の地位、もしくは本契約に基づく一切の権利または義務を当法人の書面によ
る事前の承諾なく、第三者に譲渡、もしくは担保の目的に供してはなりません。
３．先生は、他の先生、利用契約者及び生徒を含む本サービス関係者に対して一切の勧誘行為、営業活動等をしてはなりません。
４．先生は、他の先生、利用契約者及び生徒を含む本サービス関係者と個人的な連絡先の交換、個人的な接触、先生業務及び オンライン対話学習事業に関連しない事項の連絡を行ってはなりません。
５．当法人は、先生が以下の行為を行うことを一切禁止し、違反した場合は本約款第２３条を適用
し、契約を解除します。
① 他の先生、利用契約者及び生徒を含む本サービス関係者に対する政治活動、政治活動への勧誘行為
② 他の先生、利用契約者及び生徒を含む本サービス関係者に対する宗教活動、宗教活動への勧誘行為
③ 他の先生、利用契約者及び生徒を含む本サービス関係者に対するセクシャルハラスメント行為
④ 他の先生、利用契約者及び生徒を含む本サービス関係者に対する暴言、パワーハラスメント行為
⑤ 他の先生、利用契約者及び生徒を含む本サービス関係者に対する犯罪行為、条例等に定める迷惑行為
⑥ 他の先生、利用契約者及び生徒を含む本サービス関係者の適正な授業進行を妨害する行為
⑦ その他先生に相応しくないと判断される一切の行為
６．当法人は、先生が利用契約者又は生徒に対して個人情報に関する質問を行うこと、利用契約
者又は生徒の個人情報の収集を行うことを一切禁止します。
７．先生はオンライン対話学習の授業を開始予定時刻の６０分前を過ぎてからキャンセルすることは出来ません。

第１７条（報酬等）
１．当法人は、先生に対して、別途報酬規定で定める報酬等（以下、「報酬等」といいます）を支払
うものとします。
２．報酬等の支払方法は、毎月末を締日とし、当該締日までに日報を提出した授業にかかる報酬等を翌月２５日までに、本部が指定する金融機関の口座に振込送金します。尚、振込手数料は当法人の負担とします
３．当法人は、先生から日報の提出がない場合は、報酬等を支払わないことができるものとし、先生もあらかじめこれに合意します。
４．利用契約者に授業料の発生する場合において、生徒が授業開始予定時刻の1時間前以降にキャンセルした場合は生徒側の「キャンセル」扱いとし、その時点をもって授業料に対する報酬を支払うものとします。また事前連絡がなく授業開始予定時刻の10分を過ぎた場合は生徒側の「無断キャンセル」とする。
５．先生側の通信環境、パソコンの状態に起因して授業が正常に行えなかった場合、当該授業の報酬の支払いを行わないことがあることに合意します。
６．報酬額は原則として生徒が授業を予約した時点での先生の状態に基づく金額とします。
７．授業における指導のために先生がテキストや教材を準備する場合、指導する生徒、その保護者にあたる利用契約者に相談の上、手配するものとする。そのテキストや教材の費用負担についても同じく、指導する生徒・利用契約者と事前に相談するものとします。
８．1単位の授業時間を50分とし、超過した分の報酬等は支払われないものとし、先生もあらかじめこれに合意します。
９．２５日が土曜日・日曜日・祝日に該当する場合、前営業日に支払うこととします。

第１８条（税務申告等）
１．先生は、自らの責任と負担により、報酬等に関する税務申告、その他必要手続き（以下、「税務申告等」といいます）を行う義務を負います。
２．先生は、税務申告等を行うにあたり、手続時に適用される税法、その他関係法令を遵守して行うものとします。
３．当法人は、先生の税法違反、税務申告懈怠・遅延、その他先生の税務に関する事項について一切の責任を負いません。

第１９条（損害賠償）
先生は、約款等に違反し、当法人に損害が生じた場合には、先生は当該損害を賠償する義務を負うものとします。

第２０条（有効期間及び解約）
１．本契約の有効期間は、本契約締結日から契約日の属する年の１２月３１日までとします。有効期間満了前までに当法人又は先生から解約の申入れがないときは、本契約は、更に１年間自動的に
延長されるものとし、以後も同様とします。
２．当法人は、先生が本契約を継続するに適さないと判断した場合は、中途解約を申入れることができます。なお、中途解約の申し入れは、解約の１ヶ月前に、先生に対して通知するものとします。

第２１条（解除）
当法人は、先生が、以下の各号の１つにでも該当した場合、何ら催告無く、契約を解除出来ます。
① 先生が、本契約申込時に虚偽の事項を申告した場合
② 先生が、本約款に違反をした場合
③ 先生が、３ヶ月以上先生業務を提供しない場合
④ 先生が、登録済みの連絡先に連絡が取れなくなった場合
⑤ その他契約の継続が困難な相当の事由があるとき

第２２条（清算）
終了原因の如何によらず、本契約が終了した場合、当法人及び先生は債権債務を速やかに清算するものとします。

第２３条（サービスの停止）
１．当法人は、以下の場合、本サービスの一部又は全部について、中止、中断又は廃止が出来ます。
① 地震、火災、台風、その他の事由により本サービスの提供が困難となった場合
② 先生に、契約解除事由が存在する場合
③ 当法人の経営判断により、本サービスの廃止、停止又は譲渡を決定した場合
２．本サービスの中止・変更等の情報は、遅滞なく先生に通知するものとします。
３．授業中に発生した天災地変やシステム障害等により、授業が中断した場合の報酬は支払わない
ものとする。

第２４条（免責）
当法人は、以下の各号の場合、一切の責任を負わないものとします。
① 損害が、不可抗力、その他当法人の責に帰すことができない事由により生じた場合
② 損害が、先生の責により生じた場合
③ 損害が、本約款に定めるサービス停止事由により生じた場合

第２５条（協議事項）
本約款に定めない事項について疑義を生じた場合には、その都度、先生と当法人は、誠意をもって協議を行うものとします。

第２６条（準拠法）
本約款及び本契約に関する事項は、日本国法を準拠法とします。

第２７条（合意管轄裁判所）
本契約及び本約款上の紛争、その他関連する一切の紛争については、訴額に応じて当法人の所在地を管轄する地方裁判所又は簡易裁判所を第一審の専属的合意管轄裁判所とします。

第２８条（存続条項）
本契約終了後も第１５条（競業避止）、第１６条（秘密保持）及び第２０条（損害賠償）は、有効に存続するものとします。

以上

報酬等規定
１．報酬に関して
（１） 本登録の先生
１単位基本報酬（税込）：１２００円

（２） 報酬支払時期
報酬は毎月末日締め、翌月の２５日支払いです。２５日が土曜日・日曜日・祝日に該当する場合、前営業日に支払うこととします。報酬支払銀行口座は、指定の銀行となります。
ただし、日報の提出をもって先生報酬が支払われるものとし授業終了から７２時間以内に日報の記入・提出が無い場合は、原則として当該先生報酬は支払を行いません。




令和2年7月31日制定
令和2年8月3日改定
令和3年8月16日改定
令和4年2月11日改定
令和4年12月14日改定

大阪府大阪市中央区
安堂寺町1丁目3-12 大阪谷町ビル4F

NPO法人 Silent Voice
代表理事 尾中 友哉


`;
  return `<pre>${kiyaku}</pre>`;
}
